import { render, staticRenderFns } from "./ExistingWillChangesChildrenDetails.vue?vue&type=template&id=58c2f01d"
import script from "./ExistingWillChangesChildrenDetails.vue?vue&type=script&lang=js"
export * from "./ExistingWillChangesChildrenDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports